import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The 360 SPINAL SHIELD™ (6 Volumes, 160+ pages)',
  price: '$54'
}, {
  label: '🎁 Bonus #1: The Sciatica Emergency SOS Kit',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The Pain-Free Workspace Blueprint',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: Morning Mobility Flow',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: The Anti-Inflammatory Kitchen',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: The Shielded Daily Progress Tracker',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-257" data-mp="1tgeli5i3pywd">
      
    </section>;
}